module.exports = __webpack_public_path__ + "img/_con4.a28a4b0c.png";